import {
  Context,
  useFacetFactory,
  FacetSearchResult
} from '@vue-storefront/core';
import type {
  UseFacetSearchParams as SearchParams
} from '../types';
import { useApiError } from '../useApiError';
const factoryParams = {
  provide: () => ({
    useApiError: useApiError()
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  search: async (context: Context, params: FacetSearchResult<SearchParams>): Promise<any> => {
    const query: SearchParams = {
      catId: params.input.catId || 0,
      limit: params.input.limit || 10,
      page: params.input.page || 1,
      sort: params.input.sort || '',
      subCatId: params.input.subCatId || 0,
      q: params.input.q || ''
    };
    const res = await context.$xbuy.api.getProduct(query);
    if (res && res.code && res.code > 0) {
      context.useApiError.set(res);
      // throw new Error(res.message);
    }
    return res.data;
  }
};

export const useFacet = useFacetFactory<SearchParams>(factoryParams);
